import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column w-300px w-lg-350px p-5",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "input-group input-group-solid mb-5" }
const _hoisted_3 = { class: "input-group-prepend" }
const _hoisted_4 = { class: "input-group-text" }
const _hoisted_5 = { class: "svg-icon svg-icon-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  class: "form-control ps-0",
  name: "search",
  value: "",
  placeholder: "Filter reports"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<ul class=\"nav nav-line-tabs nav-line-tabs-2x border-light fw-bold mb-5\"><li class=\"nav-item\"><a class=\"nav-link active\" data-bs-toggle=\"tab\" href=\"#kt_dropdown_2_tab_1\">Today</a></li><li class=\"nav-item\"><a class=\"nav-link\" data-bs-toggle=\"tab\" href=\"#kt_dropdown_2_tab_2\">Last Week</a></li></ul>", 1)
const _hoisted_8 = { class: "tab-content" }
const _hoisted_9 = {
  class: "tab-pane active",
  id: "kt_dropdown_2_tab_1"
}
const _hoisted_10 = { class: "menu menu-custom menu-column menu-rounded menu-title-gray-600 menu-icon-muted menu-hover-bg-light-primary menu-active-bg-light-primary fw-bold" }
const _hoisted_11 = { class: "menu-item py-1" }
const _hoisted_12 = {
  href: "#",
  class: "menu-link px-3"
}
const _hoisted_13 = { class: "menu-icon" }
const _hoisted_14 = { class: "svg-icon svg-icon-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, " Web & App History ", -1)
const _hoisted_16 = { class: "menu-item py-1" }
const _hoisted_17 = {
  href: "#",
  class: "menu-link px-3"
}
const _hoisted_18 = { class: "menu-icon" }
const _hoisted_19 = { class: "svg-icon svg-icon-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, " Activity and Timeline ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "menu-badge badge badge-light-danger fw-bold" }, " new ", -1)
const _hoisted_22 = { class: "menu-item py-1" }
const _hoisted_23 = {
  href: "#",
  class: "menu-link px-3"
}
const _hoisted_24 = { class: "menu-icon" }
const _hoisted_25 = { class: "svg-icon svg-icon-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, " Business Features ", -1)
const _hoisted_27 = { class: "menu-item py-1" }
const _hoisted_28 = {
  href: "#",
  class: "menu-link px-3"
}
const _hoisted_29 = { class: "menu-icon" }
const _hoisted_30 = { class: "svg-icon svg-icon-1" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, " Accessibility Settings ", -1)
const _hoisted_32 = { class: "menu-item py-1" }
const _hoisted_33 = {
  href: "#",
  class: "menu-link px-3"
}
const _hoisted_34 = { class: "menu-icon" }
const _hoisted_35 = { class: "svg-icon svg-icon-1" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, " Data & Personalisation ", -1)
const _hoisted_37 = { class: "menu-item py-1" }
const _hoisted_38 = {
  href: "#",
  class: "menu-link px-3"
}
const _hoisted_39 = { class: "menu-icon" }
const _hoisted_40 = { class: "svg-icon svg-icon-1" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, " General Preference ", -1)
const _hoisted_42 = {
  class: "tab-pane",
  id: "kt_dropdown_2_tab_2"
}
const _hoisted_43 = { class: "menu menu-custom menu-column menu-rounded menu-title-gray-600 menu-icon-muted menu-hover-bg-light-primary menu-active-bg-light-primary fw-bold" }
const _hoisted_44 = { class: "menu-item py-1" }
const _hoisted_45 = {
  href: "#",
  class: "menu-link active px-3"
}
const _hoisted_46 = { class: "menu-icon" }
const _hoisted_47 = { class: "svg-icon svg-icon-1" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, " Activity and Timeline ", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("span", { class: "menu-badge badge badge-danger fw-bold" }, " new ", -1)
const _hoisted_50 = { class: "menu-item py-1" }
const _hoisted_51 = {
  href: "#",
  class: "menu-link px-3"
}
const _hoisted_52 = { class: "menu-icon" }
const _hoisted_53 = { class: "svg-icon svg-icon-1" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, " Business Features ", -1)
const _hoisted_55 = { class: "menu-item py-1" }
const _hoisted_56 = {
  href: "#",
  class: "menu-link px-3"
}
const _hoisted_57 = { class: "menu-icon" }
const _hoisted_58 = { class: "svg-icon svg-icon-1" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, " Accessibility Settings ", -1)
const _hoisted_60 = { class: "menu-item py-1" }
const _hoisted_61 = {
  href: "#",
  class: "menu-link px-3"
}
const _hoisted_62 = { class: "menu-icon" }
const _hoisted_63 = { class: "svg-icon svg-icon-1" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, " Data & Personalisation ", -1)
const _hoisted_65 = { class: "menu-item py-1" }
const _hoisted_66 = {
  href: "#",
  class: "menu-link px-3"
}
const _hoisted_67 = { class: "menu-icon" }
const _hoisted_68 = { class: "svg-icon svg-icon-1" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, " General Preference ", -1)
const _hoisted_70 = { class: "menu-item py-1" }
const _hoisted_71 = {
  href: "#",
  class: "menu-link px-3"
}
const _hoisted_72 = { class: "menu-icon" }
const _hoisted_73 = { class: "svg-icon svg-icon-1" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("span", { class: "menu-title" }, " Web & App History ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/Search.svg" })
          ])
        ])
      ]),
      _hoisted_6
    ]),
    _hoisted_7,
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("ul", _hoisted_10, [
          _createElementVNode("li", _hoisted_11, [
            _createElementVNode("a", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/Search.svg" })
                ])
              ]),
              _hoisted_15
            ])
          ]),
          _createElementVNode("li", _hoisted_16, [
            _createElementVNode("a", _hoisted_17, [
              _createElementVNode("span", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/Search.svg" })
                ])
              ]),
              _hoisted_20,
              _hoisted_21
            ])
          ]),
          _createElementVNode("li", _hoisted_22, [
            _createElementVNode("a", _hoisted_23, [
              _createElementVNode("span", _hoisted_24, [
                _createElementVNode("span", _hoisted_25, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/Search.svg" })
                ])
              ]),
              _hoisted_26
            ])
          ]),
          _createElementVNode("li", _hoisted_27, [
            _createElementVNode("a", _hoisted_28, [
              _createElementVNode("span", _hoisted_29, [
                _createElementVNode("span", _hoisted_30, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Design/Flatten.svg" })
                ])
              ]),
              _hoisted_31
            ])
          ]),
          _createElementVNode("li", _hoisted_32, [
            _createElementVNode("a", _hoisted_33, [
              _createElementVNode("span", _hoisted_34, [
                _createElementVNode("span", _hoisted_35, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Design/Flatten.svg" })
                ])
              ]),
              _hoisted_36
            ])
          ]),
          _createElementVNode("li", _hoisted_37, [
            _createElementVNode("a", _hoisted_38, [
              _createElementVNode("span", _hoisted_39, [
                _createElementVNode("span", _hoisted_40, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/Notification2.svg" })
                ])
              ]),
              _hoisted_41
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("ul", _hoisted_43, [
          _createElementVNode("li", _hoisted_44, [
            _createElementVNode("a", _hoisted_45, [
              _createElementVNode("span", _hoisted_46, [
                _createElementVNode("span", _hoisted_47, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/Mail-heart.svg" })
                ])
              ]),
              _hoisted_48,
              _hoisted_49
            ])
          ]),
          _createElementVNode("li", _hoisted_50, [
            _createElementVNode("a", _hoisted_51, [
              _createElementVNode("span", _hoisted_52, [
                _createElementVNode("span", _hoisted_53, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/Incoming-box.svg" })
                ])
              ]),
              _hoisted_54
            ])
          ]),
          _createElementVNode("li", _hoisted_55, [
            _createElementVNode("a", _hoisted_56, [
              _createElementVNode("span", _hoisted_57, [
                _createElementVNode("span", _hoisted_58, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Design/Flatten.svg" })
                ])
              ]),
              _hoisted_59
            ])
          ]),
          _createElementVNode("li", _hoisted_60, [
            _createElementVNode("a", _hoisted_61, [
              _createElementVNode("span", _hoisted_62, [
                _createElementVNode("span", _hoisted_63, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Design/Saturation.svg" })
                ])
              ]),
              _hoisted_64
            ])
          ]),
          _createElementVNode("li", _hoisted_65, [
            _createElementVNode("a", _hoisted_66, [
              _createElementVNode("span", _hoisted_67, [
                _createElementVNode("span", _hoisted_68, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/Notification2.svg" })
                ])
              ]),
              _hoisted_69
            ])
          ]),
          _createElementVNode("li", _hoisted_70, [
            _createElementVNode("a", _hoisted_71, [
              _createElementVNode("span", _hoisted_72, [
                _createElementVNode("span", _hoisted_73, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Files/Media.svg" })
                ])
              ]),
              _hoisted_74
            ])
          ])
        ])
      ])
    ])
  ]))
}